import React from 'react';

const Context = React.createContext({
    actionOption: undefined,
    consents: false,
    setActionOption: () => {},
    setConsents: () => {}
});

export default Context;
